'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _NewsMenu = require('./NewsMenu');

var _NewsMenu2 = _interopRequireDefault(_NewsMenu);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _NewsMenu2.default;


//////////////////
// WEBPACK FOOTER
// ./~/@surfline/quiver-react/dist/NewsMenu/index.js
// module id = 309
// module chunks = 0